import { PayloadAction } from '@reduxjs/toolkit';
import { ProcessedStatusList } from '@/store/types';
import { createSliceSteamup } from '../common';

//  처리상태 모달들 | 판매 상태
type ModalType = 'handleSales' | 'list' | 'request' | 'complete' | 'reject';

// 'list' 타입을 제외한 모든 타입을 InnerModalType으로 정의
export type ExcludeListType<T> = T extends 'list' | 'handleSales' ? never : T;
export type InnerModalType = ExcludeListType<ModalType>;

interface ISalesClassRoom {
  uuid: string;
  price: number; // 상품 가격
  title: string; // 상품 제목
  createdAt: Date; // 상품 등록 날짜
  disabledAt: Date;
  salesState: boolean; // 판매상태
}

interface ISalesStore {
  uuid: string;
  price: number; // 상품 가격
  title: string; // 상품 제목
  createdAt: Date; // 상품 등록 날짜
  salesType: '0' |'1';
  salesState: boolean; // 판매상태
  disabledAt: Date;
}

interface DashBoardState {
  loading: boolean;
  lastPage: string;
  tableType: 'class_room' | 'store';
  currMenu: 'all' | 'selling' | 'soldOut' | 'approval'; // TODO: common type에 있는 temp과 통일해서 사용하기
  // 검색
  q: string,
  // 아래 부분은 간소화로 수정될 예정
  dashboardModalType: ModalType;
  innerModalType: InnerModalType;

  salesClassroomData: ISalesClassRoom;
  salesStoreDate: ISalesStore;

  refundDataList: ProcessedStatusList[];
  refundData: ProcessedStatusList;
}

const initSalesClassroomData:ISalesClassRoom = {
  uuid: '',
  title: '',
  price: 0,
  createdAt: new Date(),
  disabledAt: new Date(),
  salesState: true,
};

const initSalesStoreData:ISalesStore = {
  uuid: '',
  title: '',
  price: 0,
  createdAt: new Date(),
  disabledAt: new Date(),
  salesType: '0',
  salesState: true,
};

const initRefundData = {
  uuid: '',
  purchasedAt: 0,
  refundRequestedAt: 0,
  refundedAt: 0,
  retractedAt: 0,
  rejectionAt: 0,
  readAt: 0,
  storeCategoryID: 0,
  refundContent: '',
  rejectionContent: '',
  usedPoint: 0,
  usedMileage: 0,
  salesTypeNumber: 0,
  refundStatusTypeID: 0,
  purchaserUUID: '',
  purchaserAvatarURL: '',
  purchaserName: '',
  purchaserEmail: '',
};

const dashBoardSlice = createSliceSteamup(
  'dashboard',
  {
    loading: true,
    lastPage: '/',
    tableType: 'class_room',
    currMenu: 'all',
    // 검색
    q: '',

    // 아래 부분은 간소화로 수정될 예정
    dashboardModalType: 'list',
    innerModalType: 'request',
    salesClassroomData: initSalesClassroomData,
    salesStoreDate: initSalesStoreData,
    refundDataList: [],
    refundData: initRefundData,
  } as DashBoardState,
  {
    setLastPage(state, { payload }: PayloadAction<(typeof state.lastPage)>) {
      state.lastPage = payload;
    },
    setIsSalesEnabled(state, { payload }: PayloadAction<boolean>) {
      if (state.tableType === 'class_room') {
        state.salesClassroomData.salesState = payload;
      } else {
        state.salesStoreDate.salesState = payload;
      }
    },
  },
);

export default dashBoardSlice;
